import React, { useState, useEffect } from "react";
import {
    Typography,
    Button,
    Box,
    Chip,
} from "@mui/material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import { FormatDate } from "../../../utils/FormatDate";
import { FormatToBrl } from "../../../utils/FormatToBrl";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HomeIcon from '@mui/icons-material/Home';
import ModalCancelarAssinatura from "./ModalCancelarAssinatura";
import { Breadcrumbs, Link } from "@mui/material";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const botaoSecundarioSx = {
    textTransform: "none",
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    backgroundColor: "#f3f4f6",
    borderRadius: "8px",
    px: 2,
    "&:hover": { backgroundColor: "#e5e7eb" },
};

const botaoPrimarioSx = {
    textTransform: "none",
    fontSize: 13,
    fontWeight: 700,
    color: "#111827",
    backgroundColor: "#ffc845",
    borderRadius: "8px",
    boxShadow: "none",
    px: 2,
    "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" },
};

const CardTitulo = ({ icone, titulo, descricao }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Box
            sx={{
                width: 36,
                height: 36,
                borderRadius: "8px",
                backgroundColor: "#f3f4f6",
                color: "#374151",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                "& svg": { fontSize: 20 },
            }}
        >
            {icone}
        </Box>
        <Box>
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>{titulo}</Typography>
            {descricao && <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{descricao}</Typography>}
        </Box>
    </Box>
);

const InfoRow = ({ label, value }) => (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 2, py: 1, borderBottom: "1px solid #f3f4f6", "&:last-of-type": { borderBottom: "none" } }}>
        <Typography sx={{ fontSize: 13, color: "#6b7280", flexShrink: 0 }}>{label}</Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827", textAlign: "right", wordBreak: "break-word" }}>{value}</Typography>
    </Box>
);

const LinkLista = ({ icone, label, descricao, onClick }) => (
    <Box
        onClick={onClick}
        sx={{ display: "flex", alignItems: "center", gap: 1.5, px: 1.5, py: 1.25, borderRadius: "8px", cursor: "pointer", "&:hover": { backgroundColor: "#f3f4f6" } }}
    >
        <Box sx={{ display: "flex", color: "#6b7280", "& svg": { fontSize: 18 } }}>{icone}</Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>{label}</Typography>
            {descricao && <Typography sx={{ fontSize: 11, color: "#6b7280" }}>{descricao}</Typography>}
        </Box>
        <ChevronRightIcon sx={{ fontSize: 18, color: "#9ca3af" }} />
    </Box>
);

const Assinatura = () => {
    const { user } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalCancelarAssinatura, setOpenModalCancelarAssinatura] = useState(false);

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

        if (hasFaturasVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    const assinaturaAtiva = user?.assinatura?.status === "ACTIVE";
    const metodoPagamento = user?.asaas?.billingType === "BOLETO" ? "Boleto" : "Cartão de Crédito";
    const proximaCobranca = user?.assinatura?.proximaCobranca ? FormatDate(user.assinatura.proximaCobranca) : "-";
    const faturasVencidas = user?.faturas?.vencidas?.length || 0;

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Assinatura & Cobranças
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Assinatura e Cobrança
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Gerencie seu plano, forma de pagamento e cobranças em um só lugar.
                        </Typography>
                    </Box>
                    <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("../Dashboard")} sx={{ ...botaoSecundarioSx, alignSelf: { xs: "flex-start", md: "center" } }}>
                        Voltar
                    </Button>
                </Box>

                {faturasVencidas > 0 && (
                    <Box
                        sx={{
                            mt: 2,
                            display: "flex",
                            alignItems: { xs: "flex-start", sm: "center" },
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            gap: 1.5,
                            backgroundColor: "#fef3c7",
                            border: "1px solid #fde68a",
                            borderRadius: "12px",
                            px: 2,
                            py: 1.5,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#b45309" }}>
                            <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                Você tem {faturasVencidas} {faturasVencidas === 1 ? "fatura vencida" : "faturas vencidas"}. Regularize para continuar usufruindo dos nossos serviços.
                            </Typography>
                        </Box>
                        <Button onClick={() => navigate("../Dashboard/Faturas/Pendentes")} sx={{ ...botaoPrimarioSx, flexShrink: 0 }}>
                            Ver faturas
                        </Button>
                    </Box>
                )}

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 3fr) minmax(0, 2fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {/* Plano atual */}
                        <Box sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Chip
                                    label="Plano atual"
                                    size="small"
                                    sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                                />
                                <Chip
                                    label={assinaturaAtiva ? "Ativo" : "Inativo"}
                                    size="small"
                                    sx={{
                                        backgroundColor: assinaturaAtiva ? "rgba(34, 197, 94, 0.15)" : "rgba(239, 68, 68, 0.15)",
                                        color: assinaturaAtiva ? "#4ade80" : "#f87171",
                                        fontWeight: 700,
                                        fontSize: 10,
                                        height: 20,
                                        letterSpacing: 0.6,
                                        textTransform: "uppercase",
                                    }}
                                />
                            </Box>

                            <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box sx={{ width: 48, height: 48, borderRadius: "10px", backgroundColor: "rgba(255, 255, 255, 0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <WorkspacePremiumIcon sx={{ color: "#ffc845", fontSize: 28 }} />
                                </Box>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{user?.plano?.nome || "Plano não definido"}</Typography>
                                    <Typography sx={{ fontSize: 13, color: "#cbd5e1" }}>{user?.plano?.descricao || "-"}</Typography>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    mt: 2.5,
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                    gap: 1.5,
                                }}
                            >
                                <Box sx={{ backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                    <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Valor da assinatura</Typography>
                                    <Typography sx={{ mt: 0.5, fontSize: 24, fontWeight: 700, color: "#ffc845" }}>{FormatToBrl(user?.asaas?.value || 0)}</Typography>
                                </Box>
                                <Box sx={{ backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                    <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Próxima cobrança</Typography>
                                    <Box sx={{ mt: 0.5, display: "flex", alignItems: "center", gap: 1 }}>
                                        <EventOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                                        <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{proximaCobranca}</Typography>
                                    </Box>
                                </Box>
                            </Box>

                            <Box sx={{ mt: 2.5, display: "flex", gap: 1, flexWrap: "wrap" }}>
                                <Button variant="contained" startIcon={<SwapHorizIcon />} onClick={() => navigate("../Dashboard/MudarPlano")} sx={{ ...botaoPrimarioSx, flex: { xs: 1, sm: "none" } }}>
                                    Mudar meu plano
                                </Button>
                                <Button
                                    startIcon={<ReceiptLongOutlinedIcon />}
                                    onClick={() => navigate("../Dashboard/DetalhesCobranca")}
                                    sx={{ ...botaoSecundarioSx, flex: { xs: 1, sm: "none" }, color: "#fff", backgroundColor: "rgba(255, 255, 255, 0.08)", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.14)" } }}
                                >
                                    Detalhes de cobrança
                                </Button>
                            </Box>
                        </Box>

                        {/* Faturas */}
                        <Box sx={{ ...cardSx, p: { xs: 1.5, md: 2 } }}>
                            <Box sx={{ px: 1.5, pt: 0.5 }}>
                                <CardTitulo icone={<DescriptionOutlinedIcon />} titulo="Faturas" descricao="Acompanhe suas cobranças em aberto e o histórico de pagamentos" />
                            </Box>
                            <LinkLista
                                icone={<WarningAmberRoundedIcon sx={{ color: faturasVencidas > 0 ? "#d97706" : undefined }} />}
                                label="Faturas pendentes"
                                descricao={faturasVencidas > 0 ? `${faturasVencidas} vencida(s)` : "Nenhuma fatura vencida"}
                                onClick={() => navigate("../Dashboard/Faturas/Pendentes")}
                            />
                            <LinkLista icone={<TaskAltOutlinedIcon />} label="Faturas pagas" descricao="Histórico e comprovantes" onClick={() => navigate("../Dashboard/Faturas/Pagas")} />
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {/* Pagamento */}
                        <Box sx={cardSx}>
                            <CardTitulo icone={<CreditCardIcon />} titulo="Forma de pagamento" descricao="Usada nas próximas cobranças" />
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 1.5 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                    <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#0b243d", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {user?.asaas?.billingType === "BOLETO"
                                            ? <DescriptionOutlinedIcon sx={{ fontSize: 18, color: "#ffc845" }} />
                                            : <CreditCardIcon sx={{ fontSize: 18, color: "#ffc845" }} />}
                                    </Box>
                                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>{metodoPagamento}</Typography>
                                </Box>
                                <Button size="small" onClick={() => navigate("../Dashboard/alterarMetodoPagamento")} sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: "#111827", "&:hover": { backgroundColor: "#e5e7eb" } }}>
                                    Alterar
                                </Button>
                            </Box>
                        </Box>

                        {/* Titular */}
                        <Box sx={cardSx}>
                            <CardTitulo icone={<PersonOutlineIcon />} titulo="Titular da assinatura" />
                            <InfoRow label="Nome" value={user?.usuario?.nome || "Nome não disponível"} />
                            <InfoRow label="E-mail" value={user?.usuario?.email || "Email não disponível"} />
                            <InfoRow label="Telefone" value={user?.usuario?.telefone ? MascaraTelefone(user.usuario.telefone) : "-"} />
                            <Button size="small" endIcon={<ChevronRightIcon />} onClick={() => navigate("../Dashboard/Perfil")} sx={{ mt: 1, textTransform: "none", fontSize: 12, fontWeight: 700, color: "#111827", p: 0, minWidth: 0, "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}>
                                Editar dados
                            </Button>
                        </Box>

                        {/* Cancelamento */}
                        <Box sx={{ ...cardSx, borderColor: "#fecaca" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                                <HistoryOutlinedIcon sx={{ fontSize: 18, color: "#b91c1c" }} />
                                <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#b91c1c" }}>Cancelar assinatura</Typography>
                            </Box>
                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                Deseja encerrar sua assinatura? Você poderá revisar os detalhes antes de confirmar.
                            </Typography>
                            <Button
                                variant="outlined"
                                onClick={() => setOpenModalCancelarAssinatura(true)}
                                sx={{ mt: 1.5, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#b91c1c", borderColor: "#fecaca", borderRadius: "8px", "&:hover": { backgroundColor: "#fef2f2", borderColor: "#fca5a5" } }}
                            >
                                Cancelar assinatura
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ModalCancelarAssinatura
                openModalCancelarAssinatura={openModalCancelarAssinatura}
                setOpenModalCancelarAssinatura={setOpenModalCancelarAssinatura}
            />
        </>
    )
}

export default Assinatura;
